export default __webpack_public_path__ + "static/media/trms.ddc0cecc.png";